import React from 'react';
import { useTheme } from '../context/shared/ThemeContext'
import type { SuggestionsModalProps } from '../../shared/types/src';

const SuggestionsModal: React.FC<SuggestionsModalProps> = ({
  isOpen,
  onClose,
  suggestions,
  onSelectSuggestion
}) => {
  const { themeClasses } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className={`${themeClasses.cardBg} rounded-lg shadow-xl max-w-lg w-full max-h-[80vh] overflow-hidden`}>
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className={`text-xl font-semibold ${themeClasses.primaryText}`}>
              <span role="img" aria-label="lightbulb" className="mr-2">💡</span>
              Suggestions
            </h2>
            <button
              onClick={onClose}
              className={`${themeClasses.mutedText} hover:opacity-75 transition-opacity`}
            >
              <span role="img" aria-label="close">✕</span>
            </button>
          </div>

          <div className="overflow-y-auto max-h-[60vh]">
            {suggestions.length > 0 ? (
              <div className="space-y-2">
                {suggestions.map((suggestion, index) => (
                  <button
                    key={index}
                    onClick={() => onSelectSuggestion(suggestion)}
                    className={`w-full text-left p-3 rounded-lg transition-colors
                      ${themeClasses.secondaryCardBg} hover:${themeClasses.hover}
                      ${themeClasses.primaryText}`}
                  >
                    {suggestion}
                  </button>
                ))}
              </div>
            ) : (
              <p className={`text-center ${themeClasses.mutedText}`}>
                No suggestions available yet. Continue chatting to get personalized suggestions.
              </p>
            )}
          </div>

          <div className="mt-6 text-center">
            <button
              onClick={onClose}
              className={`${themeClasses.buttonSecondary} from py-2 rounded-lg`}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuggestionsModal; 